import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { utcFormat } from 'd3-time-format';
import { Type } from '@spotify-internal/encore-creator-web';
import { gray45, screenSmMin } from '@spotify-internal/encore-foundation';
import { lastSevenDays } from '../../HomeHelper';

const ThisWeek = styled.div`
  align-items: baseline;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  @media (min-width: ${screenSmMin}) {
    grid-area: statsheader;
    grid-row-start: 2;
  }
`;

export const homeDateFormat = utcFormat('%b %e');

const StatsTopHeader = React.memo(props => {
  return (
    <ThisWeek>
      <Type.h1 variant={Type.heading3} weight={Type.bold} condensed>
        Last 7 days
      </Type.h1>
      {props.latestDate ? (
        <Type.p variant={Type.cta4} color={gray45}>
          {lastSevenDays(props.latestDate, homeDateFormat)}
        </Type.p>
      ) : null}
    </ThisWeek>
  );
});

StatsTopHeader.propTypes = {
  latestDate: PropTypes.string,
};

/* eslint-disable-next-line import/no-default-export */
export default StatsTopHeader;
